import { render } from "./DemoSettingsModal.vue?vue&type=template&id=1d656a46"
import script from "./DemoSettingsModal.vue?vue&type=script&lang=js"
export * from "./DemoSettingsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__